export default class ClientEnvironmentModel {
    ClientId:number;
    Name:string;
    ClientUrl:string;
    BranchName:string;
    DatabaseName:string;
    APIUrl: string;
    FaviconPath: string;
    ApplicationId?: number;
    PortNumber?: number;
}
